import { render, staticRenderFns } from "./CourseItem.vue?vue&type=template&id=02bf5f26&scoped=true&"
import script from "./CourseItem.vue?vue&type=script&lang=ts&"
export * from "./CourseItem.vue?vue&type=script&lang=ts&"
import style0 from "./CourseItem.vue?vue&type=style&index=0&id=02bf5f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bf5f26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('02bf5f26', component.options)
    } else {
      api.reload('02bf5f26', component.options)
    }
    module.hot.accept("./CourseItem.vue?vue&type=template&id=02bf5f26&scoped=true&", function () {
      api.rerender('02bf5f26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/learningPaths/CourseItem.vue"
export default component.exports